import { InteractionTypes } from '@/entities/interaction';
import { InteractionList } from '@/widgets/interaction-list';

export default function TrustReceivedPage() {
  return (
    <InteractionList
      type={InteractionTypes.TRUST_REQUESTED}
      direction="received"
      title="Demandes de contact reçues"
      emptyMessage="Aucune demande de contact reçue pour le moment."
    />
  );
}
